import { Box, BoxProps, Typography } from '@mui/material';
import React from 'react';
import { AppBarStyles } from '@client/style/style.constants';
import { mergeSx } from '@client/helpers/mui.helpers';

export interface EmptyStateProps extends BoxProps {
  message: string;
  fullHeight?: boolean;
  heightOffset?: number;
}

const emptyStateLayoutSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
} as const;

const EmptyState: React.FC<EmptyStateProps> = ({
  message,
  heightOffset = DEFAULT_HEIGHT_OFFSET,
  fullHeight = false,
  ...props
}) => {
  const height = fullHeight
    ? `calc(100vh - ${AppBarStyles.HEIGHT + heightOffset}px)`
    : 'auto';

  return (
    <Box {...props} sx={mergeSx(emptyStateLayoutSx, { height }, props.sx)}>
      <Typography
        variant="h6"
        sx={{
          fontWeight: fullHeight ? 600 : 400,
        }}
      >
        {message}
      </Typography>
    </Box>
  );
};

/**
 * Default height offset is height of MainCategoriesOverview + ListHeader + Proposals + ProjectViewHeader
 */
const DEFAULT_HEIGHT_OFFSET = 200 + 3 * 50;

export default EmptyState;
